'use client';

import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQAccordionClientProps {
  faqs: FAQItem[];
}

export default function FAQAccordionClient({ faqs }: FAQAccordionClientProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="space-y-4">
      {faqs?.map((faq, index) => (
        <div
          key={index}
          className="bg-[#0d1f2d] border border-[#1e3a5f] rounded-lg overflow-hidden"
        >
          <button
            className="w-full text-left px-6 py-5 flex justify-between items-start gap-4 hover:bg-[#08294a] transition-colors"
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
            aria-expanded={openIndex === index}
          >
            <span className="text-white font-semibold text-lg leading-snug">{faq?.question}</span>
            <span className="text-[#e8a020] text-2xl font-light flex-shrink-0 mt-0.5">
              {openIndex === index ? '−' : '+'}
            </span>
          </button>
          {openIndex === index && (
            <div className="px-6 pb-6">
              <p className="text-gray-300 leading-relaxed text-base">{faq?.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
